export default __webpack_public_path__ + "static/media/image_13.cc8a32c1.jpg";